import React from 'react';
import ReactDOM from 'react-dom/client';
import 'calc-controls/styles.css';
import { AlertProvider } from '@ascend/alert';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './components/AppGate';
import './styles/tokens.css';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppLockProvider>
      <AlertProvider>
        <AppGate />
      </AlertProvider>
    </AppLockProvider>
  </React.StrictMode>,
);
